import { useState } from 'react'
import Modal from '../../../../components/Modal'
import '../FavouriteItem/FavouriteItem.scss'
import ButtonCart from '../../../../components/ButtonCart'
import { Button } from '@mui/material'

const  FavouriteItem = ({title,url,color,id,price,removeFromFavourite,inFavourite,addToCart}) =>{
    
    const [modalDelFav,setModalDelFav] = useState(false)
    const [modalAddCart,setModalAddCart] = useState(false)


    const deleteFromFav = () =>{
        removeFromFavourite(inFavourite)
    }
    const addCart = () =>{
        addToCart(inFavourite)
    }
    const actionsCart = 
    <div style={{display: 'flex'}}>
          
          <ButtonCart color="primary" variant="contained"  onClick={()=>{addCart();deleteFromFav()}}/>
          
          <Button color="primary" variant="contained" style={{marginLeft:'10px'}}  onClick={()=>{setModalAddCart(false)}}>CANCEL</Button>
          
    </div>
  const actionsFav = 
  <div className="cart-item__actions">
        <Button color="primary" variant="contained" style={{marginLeft:'10px'}}  onClick={deleteFromFav}>DELETE</Button>
        <Button color="primary" variant="contained" style={{marginLeft:'10px'}}  onClick={()=>{setModalAddCart(false)}}>CANCEL</Button>
  </div>

    return (
    
    <>
    <div className="favourite-item">
                <div className="favourite-item__header">
                    <img className="favourite-item___header-img" src={url} alt="img" />
                    <div className='favourite-item__header-delete'>
                        <button className='favourite-item__header-delete--btn' onClick={()=>{setModalDelFav(true)}}>&#10006;</button>
                        {modalDelFav &&
                        <Modal
                            header='Do you want delete this product from favourite?'
                            text='This product will be deleted from the favorite!'
                            btnClose={()=>{setModalDelFav(false)}}
                            actions={actionsFav}
                        />
                    
                    }
                    </div>
                </div>
                    
                
                <div className="favourite-item__content">
                    <p className="favourite-item__content-title">{title}</p>
                    <p className="favourite-item__content-color">Color: {color}</p>
                    <p className="favourite-item__content-article">Product id: {id}</p>

                </div>
                <div className="favourite-item__footer">
                    <p className="favourite-item__footer-price">{price}$</p>
                    <ButtonCart onClick={()=>{setModalAddCart(true)}}/>
                    {modalAddCart &&
                        <Modal
                            header='Do you want to add this product to the cart?'
                            text='This product will be added to the cart!'
                            btnClose={()=>{setModalAddCart(false)}}
                            actions={actionsCart}
                        />
                    
                    }
                </div>
            </div>
    </>
    
    )
}
export default FavouriteItem;